import Image from 'next/image';
import PopupMap from "../PopupMap";
import { useContext, useEffect, useState } from 'react';
import { getInventoryProductDetailByCode } from '../../pages/api/product';
import AppContext from '../../store/AppContext';

const ShopTab = ({ detail, date, moment, isPopup=false, hidden= true, loadingStock=true }: any) => {
    const { branchs} = useContext(AppContext);
    let is_Product = detail?.data?.is_product;
    const [isLoaded, setIsLoaded]:any = useState(false);
    const [reloadStock, setReloadStock]:any = useState(true);
    isPopup = isPopup ? true : false;
    const [isOpenMap, setIsOpenMap]:any = useState({
        isOpen: false,
        embed: ""
    });
    
    useEffect(() => {
        if (hidden==false && branchs.length > 0 && !isLoaded) {
            setShops(branchs);
            setIsLoaded(true);
        }
    }, [branchs, hidden == false])

    useEffect(() => {
        if (hidden==false && loadingStock==false) {
            setTimeout(function(){
                getInventory();
            }, 100);
        }
    }, [hidden, loadingStock, detail?.selectProductDetail?.code || (date?.takeDate && date?.returnDate)])
    
    
    const [shops, setShops]:any = useState([]);
    const [shopsStock, setShopsStock]:any = useState([]);

    async function getInventory(){
        setReloadStock(true);
        if(is_Product && detail?.selectProductDetail?.code){
            if((date?.takeDate == null && date?.returnDate == null) || (date?.takeDate && date?.returnDate)){
                let from_date = date?.takeDate ? moment(date?.takeDate).format("DD/MM/YYYY HH:mm:ss") : "";
                let to_date = date?.returnDate ? moment(date?.returnDate).format("DD/MM/YYYY HH:mm:ss") : "";
                let res_Inventory: any = await getInventoryProductDetailByCode(detail?.selectProductDetail?.code, from_date, to_date);
                if(res_Inventory){
                    await setShopsStock(res_Inventory);
                }
            }
        }
        setReloadStock(false);
    }

    return <div id="tab_shop" className={"tab_shop gap-[16px] " + (isPopup ? "h-[12rem] pb-0" : "") + (hidden ? " hidden" : "")}>
        <>
        <div className="notes-branch md:pl-[24px]">*LƯU Ý: Thời gian làm việc các chi nhánh khác nhau. Quý khách vui lòng xem kỹ</div>
            {shops?.map((shop: any) => {
                let in_stock = shopsStock.find((x:any) => x.id == shop.id)?.in_stock;
                return <div key={shop.id} className="shop_item flex flex-col gap-[2px]">
                    {/* <div className='relative'>
                        <Image
                            src="/asset/image/shop_1.svg"
                            alt="g"
                            width={600}
                            height={120}
                        />
                        <div className='shop_tab_name'>
                            {shop.name}
                        </div>
                    </div> */}
                    <h3 className='text-[1rem] leading-[32px] flex flex-row gap-3 justify-between'>
                        <span className="text-semibold-quicksand">{shop?.name}</span>
                        {is_Product == false ? <></> : 
                        (reloadStock == true ? <Image priority={true} className='relative z-[12]' src={"/asset/image/loading.gif"} 
                                                alt="Đang tải" width={32} height={32}/> : (in_stock || in_stock >= 0) ? 
                            <span>{"Tồn: " + in_stock}</span> : <></>)
                        }
                    </h3>

                    <div className='leading-[20px] flex flex-row gap-3 justify-between'>
                        <p>{shop?.address ? shop.address : ""} </p>
                        <div className='flex flex-row items-center'>
                            <span className='tab_shop--map' onClick={() => {
                                    setIsOpenMap({
                                        isOpen: true,
                                        embed: shop?.address_src
                                    })
                                }}>Xem bản đồ</span>
                            {/* <Image
                                src="/asset/icon/ico_green_location.svg"
                                alt="map"
                                width={16}
                                height={16}
                            /> */}
                        </div>
                    </div>
                    <div className='flex flex-col '>
                        <div>
                        {
                            Array.isArray(shop.phone) && shop.phone?.map((item: any, index: number) => {
                                let phone = item ? item : "0986.324.594";
                                if (shop.phone.length > 1 && index !== shop.phone.length - 1) {
                                    return <>
                                        <a key={index} href={"tel:"+phone} className='my-auto tab_shop--phone'>{phone}</a>
                                        <span key={index+"_span"} className='my-auto px-1'> - </span>
                                    </>
                                }
                                return <a key={index} href={"tel:"+phone} className='my-auto tab_shop--phone'>{phone}</a>
                            })
                        }
                        </div>
                        {
                            shop?.description &&
                            <div className="notes-branch">
                                {shop?.description}
                            </div>
                        }
                        
                        {/* <span className='my-auto tab_shop--phone text-base text-[#434343] font-[500]'>{shop?.fax ? shop?.fax : "0986.324.594"}</span>
                        <span className='my-auto tab_shop--phone text-base text-[#434343] font-[500]'>{shop?.fax ? shop?.fax : "0986.324.594"}</span> <span className='my-auto px-1'> - </span><span className='tab_shop--phone my-auto'>{shop?.phone ? shop?.phone : "0986.324.594"}</span> */}
                    </div>

                </div>
            })}
        </>
        {
            isOpenMap && isOpenMap.isOpen && <PopupMap isOpen={isOpenMap.isOpen} 
            embed={isOpenMap.embed}
            setIsOpen={(agr:any) => {
                setIsOpenMap(agr)
            }} />
        }
    </div>
}

export default ShopTab;